import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { NAVIGATION_ITEM } from "common";
import { selectOrginizationDetails } from "redux/slices/orginizationSlice";
import NavigationContainers from "../navigationContainer";
import contentImage from "resources/icons/content.svg";

export default function ContentNavigation() {
  const [isOpen, setIsOpen] = useState(false);
  const features = useSelector(selectOrginizationDetails)?.features || {};
  const items = useMemo(
    () =>
      [
        features.modules && NAVIGATION_ITEM.MODULES,
        features.pathways && NAVIGATION_ITEM.PATHWAYS,
        features.programs && NAVIGATION_ITEM.PROGRAMS,
      ].filter(Boolean),
    [features.modules, features.pathways, features.programs]
  );

  if (!features.content_management || items.length === 0) return null;

  return (
    <div className="content-navigation">
      <div 
        className={`content-navigation-title ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <img src={contentImage} alt="" className="nav-icon" />
        <span>{i18next.t("labels.content")}</span>
        <span className="toggle-icon">{isOpen ? "▼" : "▶"}</span>
      </div>
      
      {isOpen && (
        <div className="content-navigation-items">
          <NavigationContainers items={items} />
        </div>
      )}
    </div>
  );
}